import api from '../../api/client';
// import React, { useState, useRef } from "react";
// import {
//   Card,
//   Modal,
//   Form,
//   Select,
//   DatePicker,
//   Input,
//   Tag,
//   message,
//   Table,
//   Space,
//   Badge,
//   Tooltip,
//   Descriptions,
//   Divider,
//   Typography,
//   Button,
//   Row,
//   Col,
//   ConfigProvider,
// } from "antd";
// import { ProTable } from "@ant-design/pro-table";
// import axios from "axios";
// import dayjs from "dayjs";
// import config from "../../config";
// import {
//   PlusOutlined,
//   HistoryOutlined,
//   InfoCircleOutlined,
//   CheckCircleOutlined,
//   CloseCircleOutlined,
//   EyeOutlined,
// } from "@ant-design/icons";
// import enUS from "antd/lib/locale/en_US";
// import { useSelector } from "react-redux";

// const { Option } = Select;
// const { Text } = Typography;
// const { RangePicker } = DatePicker;

// const MatingRecords = () => {
//   const actionRef = useRef();
//   const [form] = Form.useForm();
//   const [open, setOpen] = useState(false);
//   const [statusModal, setStatusModal] = useState(false);
//   const [selectedRecord, setSelectedRecord] = useState(null);
//   const [historyVisible, setHistoryVisible] = useState(false);
//   const [historyData, setHistoryData] = useState([]);
//   const [detailsModal, setDetailsModal] = useState(false);
//   const [selectedMating, setSelectedMating] = useState(null);
//   const [animals, setAnimals] = useState([]);
//   const [maleAnimals, setMaleAnimals] = useState([]);
//   const [femaleAnimals, setFemaleAnimals] = useState([]);
//   const [loadingAnimals, setLoadingAnimals] = useState(false);
//      const account = useSelector((state) => state.account.user);

//   const environment =
//     window.location.hostname === "localhost" ? "development" : "production";
//   const apiUrl = config[environment].apiUrl;

//   // Fetch animals from animal_assets by species and gender
//   const fetchAnimalsByType = async (species, gender) => {
//     if (!species) return [];
//     setLoadingAnimals(true);
//     try {
//       const params = {
//         type_slug: species,
//         gender: gender,
//         status: "alive",
//         archived: false,
//       };
//       const { data } = await api.get(`/animal-assets/available`, {
//         params,
//       });
//       return data;
//     } catch (error) {
//       console.error(`Error fetching ${gender} ${species}:`, error);
//       return [];
//     } finally {
//       setLoadingAnimals(false);
//     }
//   };

//   // Handle species change
//   const handleSpeciesChange = async (species) => {
//     form.setFieldsValue({
//       female_id: null,
//       male_id: null,
//       female_tag: null,
//       male_tag: null,
//     });
//     if (species) {
//       const females = await fetchAnimalsByType(species, "female");
//       const males = await fetchAnimalsByType(species, "male");
//       setFemaleAnimals(females);
//       setMaleAnimals(males);
//     } else {
//       setFemaleAnimals([]);
//       setMaleAnimals([]);
//     }
//   };

//   // Add new mating record
//   const handleAdd = async (values) => {
//     try {
//       const payload = {
//         species: values.species,
//         female_id: values.female_id,
//         female_tag: values.female_tag,
//         male_id: values.male_id || null,
//         male_tag: values.male_tag || null,
//         mating_date: values.mating_date.format("YYYY-MM-DD"),
//         method: values.method || "Natural",
//         remarks: values.remarks || null,
//         status: "Served",
//         userId: account.id,
//         userName: account.firstname,
//       };

//       const res = await api.post(`/mating/add`, payload);
//       if (res.status === 200 || res.status === 201) {
//         message.success("Mating record added successfully");
//         setOpen(false);
//         form.resetFields();
//         setFemaleAnimals([]);
//         setMaleAnimals([]);
//         actionRef.current?.reload();
//       }
//     } catch (error) {
//       console.error("Error adding mating record:", error.response?.data);
//       message.error(
//         error.response?.data?.error || "Failed to add mating record",
//       );
//     }
//   };

//   // Update status
//   const handleStatusSubmit = async (values) => {
//     try {
//       await api.post(`/mating/update-status`, {
//         id: selectedRecord.id,
//         status: values.status,
//         notes: values.notes,
//         userId: account.id,
//         userName: account.firstname,
//       });
//       message.success("Status updated successfully!");
//       setStatusModal(false);
//       actionRef.current?.reload();
//     } catch (err) {
//       console.error(err.response.data.error);
//       message.error("Failed to update status.");
//     }
//   };

//   // View history
//   const viewHistory = async (matingId) => {
//     try {
//       const res = await api.get(`/mating/status-logs/${matingId}`);
//       setHistoryData(res.data);
//       setHistoryVisible(true);
//     } catch (err) {
//       console.error("Failed to fetch logs:", err);
//       message.error("Failed to load history");
//     }
//   };

//   // Get status color
//   const getStatusColor = (status) => {
//     const colors = {
//       Pending: "default",
//       Served: "processing",
//       "Pregnant": "success",
//       "Not Pregnant": "error",
//       Aborted: "warning",
//       Missed: "warning",
//       "Delivered": "success",
//     };
//     return colors[status] || "default";
//   };

//   // ProTable columns
//   const columns = [
//     {
//       title: "Species",
//       dataIndex: "species",
//       key: "species",
//       width: 100,
//       render: (_, record) => (
//         <Text style={{ textTransform: "uppercase" }}>
//           {record.species}
//         </Text>
//       ),
//       filters: [
//         { text: "Pig", value: "pig" },
//         { text: "Goat", value: "goat" },
//         { text: "Sheep", value: "sheep" },
//       ],
//       onFilter: (value, record) => record.species === value,
//     },
//     {
//       title: "Female",
//       dataIndex: "female_tag",
//       key: "female_tag",
//       width: 150,
//       render: (_, record) => (
//         <Space>
//           <Text>{record.female_tag}</Text>
//           {record.female_breed && (
//             <Text type="secondary" style={{ fontSize: 11 }}>
//               ({record.female_breed})
//             </Text>
//           )}
//         </Space>
//       ),
//     },
//     {
//       title: "Male",
//       dataIndex: "male_tag",
//       key: "male_tag",
//       width: 150,
//       render: (_, record) =>
//         record.male_tag ? (
//           <Space>
//             <Text>{record.male_tag}</Text>
//             {record.male_breed && (
//               <Text type="secondary" style={{ fontSize: 11 }}>
//                 ({record.male_breed})
//               </Text>
//             )}
//           </Space>
//         ) : (
//           <Text type="secondary">—</Text>
//         ),
//     },
//     {
//       title: "Mating Date",
//       dataIndex: "mating_date",
//       key: "mating_date",
//       width: 120,
//       render: (_, record) => dayjs(record.mating_date).format("DD MMM YYYY"),
//       sorter: (a, b) =>
//         dayjs(a.mating_date).unix() - dayjs(b.mating_date).unix(),
//     },
//     {
//       title: "Due Date",
//       dataIndex: "expected_due_date",
//       key: "expected_due_date",
//       width: 120,
//       render: (_, record) =>
//         record.expected_due_date
//           ? dayjs(record.expected_due_date).format("DD MMM YYYY")
//           : "-",
//     },
//     {
//       title: "Status",
//       dataIndex: "status",
//       key: "status",
//       width: 140,
//       render: (_, record) => (
//         <Tooltip title="Click to update status">
//           <Tag
//             color={getStatusColor(record.status)}
//             style={{ cursor: "pointer" }}
//             onClick={() => {
//               setSelectedRecord(record);
//               form.setFieldsValue({ status: record.status, notes: "" });
//               setStatusModal(true);
//             }}
//           >
//             {record.status || "Pending"}
//           </Tag>
//         </Tooltip>
//       ),
//       filters: [
//         { text: "Pending", value: "Pending" },
//         { text: "Served", value: "Served" },
//         { text: "Confirmed Pregnant", value: "Confirmed Pregnant" },
//         { text: "Not Pregnant", value: "Not Pregnant" },
//         { text: "Aborted", value: "Aborted" },
//         { text: "Missed", value: "Missed" },
//         { text: "Delivered", value: "Delivered" },
//       ],
//       onFilter: (value, record) => record.status === value,
//     },
//     {
//       title: "Method",
//       dataIndex: "method",
//       key: "method",
//       width: 100,
//       render: (_, record) => record.method || "Natural",
//       filters: [
//         { text: "Natural", value: "Natural" },
//         { text: "AI", value: "AI" },
//       ],
//       onFilter: (value, record) => (record.method || "Natural") === value,
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       width: 120,
//       render: (_, record) => (
//         <Space>
//           <Tooltip title="View Details">
//             <Button
//               type="link"
//               size="small"
//               icon={<EyeOutlined />}
//               onClick={() => {
//                 setSelectedMating(record);
//                 setDetailsModal(true);
//               }}
//             />
//           </Tooltip>
//           <Tooltip title="View History">
//             <Button
//               type="link"
//               size="small"
//               icon={<HistoryOutlined />}
//               onClick={() => viewHistory(record.id)}
//             />
//           </Tooltip>
//         </Space>
//       ),
//     },
//   ];

//   // Request function for ProTable
//   const request = async (params, sort, filter) => {
//     try {
//       const queryParams = {};
//       if (params.species) queryParams.species = params.species;
//       if (params.status) queryParams.status = params.status;
//       if (params.method) queryParams.method = params.method;
//       if (params.farm) queryParams.farm = params.farm;
//       if (params.tag) queryParams.tag = params.tag;

//       // Handle date range from ProTable
//       if (params.mating_date && params.mating_date.length === 2) {
//         queryParams.startDate = params.mating_date[0].format("YYYY-MM-DD");
//         queryParams.endDate = params.mating_date[1].format("YYYY-MM-DD");
//       }

//       // Handle sorting
//       if (sort && Object.keys(sort).length > 0) {
//         const sortField = Object.keys(sort)[0];
//         queryParams.sort = `${sortField}:${
//           sort[sortField] === "ascend" ? "ASC" : "DESC"
//         }`;
//       }

//       const { data } = await api.get(`/mating/list`, {
//         params: queryParams,
//       });
//       return {
//         data: data,
//         success: true,
//         total: data.length,
//       };
//     } catch (error) {
//       console.error("Fetch error:", error);
//       message.error("Failed to fetch mating records.");
//       return {
//         data: [],
//         success: false,
//         total: 0,
//       };
//     }
//   };

//   // Toolbar actions
//   const toolBarRender = () => [
//     <Button
//       key="add"
//       type="primary"
//       icon={<PlusOutlined />}
//       onClick={() => setOpen(true)}
//     >
//       Add Mating Record
//     </Button>,
//   ];

//   // Search form fields for ProTable
//   const searchConfig = {
//     labelWidth: "auto",
//     optionRender: (searchConfig, formProps, dom) => [
//       ...dom,
//       <Button key="reset" onClick={() => formProps.resetFields()}>
//         Reset
//       </Button>,
//     ],
//   };

//   return (
//     <>
//       <Card title="Mating & Breeding Records">
//         <ProTable
//           actionRef={actionRef}
//           columns={columns}
//           request={request}
//           rowKey="id"
//           defaultSize="small"
//           search={searchConfig}
//           toolBarRender={toolBarRender}
//           pagination={{
//             defaultPageSize: 10,
//             showSizeChanger: true,
//             showQuickJumper: true,
//           }}
//           dateFormatter="string"
//           headerTitle={
//             <Badge count={0} showZero color="blue" style={{ marginLeft: 8 }} />
//           }
//           scroll={{ x: 1000 }}
//           options={{
//             reload: true,
//             density: true,
//             setting: true,
//           }}
//         >
//           {/* Custom filter for date range */}
//           <ProTable.Column
//             title="Mating Date Range"
//             dataIndex="mating_date"
//             key="mating_date"
//             valueType="dateRange"
//             hideInTable
//             fieldProps={{
//               placeholder: ["Start Date", "End Date"],
//             }}
//           />
//           <ProTable.Column
//             title="Tag Number"
//             dataIndex="tag"
//             key="tag"
//             valueType="text"
//             hideInTable
//             fieldProps={{
//               placeholder: "Search by tag number",
//             }}
//           />
//           <ProTable.Column
//             title="Farm"
//             dataIndex="farm"
//             key="farm"
//             valueType="text"
//             hideInTable
//             fieldProps={{
//               placeholder: "Farm ID",
//             }}
//           />
//         </ProTable>

//         {/* Add Mating Record Modal */}
//         <Modal
//           title="Add Mating Record"
//           open={open}
//           onCancel={() => {
//             setOpen(false);
//             form.resetFields();
//             setFemaleAnimals([]);
//             setMaleAnimals([]);
//           }}
//           onOk={() => form.submit()}
//           okText="Save"
//           width={600}
//         >
//           <Form form={form} layout="vertical" onFinish={handleAdd}>
//             <Form.Item
//               name="species"
//               label="Species"
//               rules={[{ required: true }]}
//             >
//               <Select
//                 onChange={handleSpeciesChange}
//                 placeholder="Select species"
//                 options={[
//                   { label: "🐷 Pig", value: "pig" },
//                   { label: "🐑 Sheep", value: "sheep" },
//                   { label: "🐐 Goat", value: "goat" },
//                 ]}
//               />
//             </Form.Item>

//             <Row gutter={16}>
//               <Col span={12}>
//                 <Form.Item
//                   name="female_id"
//                   label="Female Animal"
//                   rules={[{ required: true }]}
//                 >
//                   <Select
//                     showSearch
//                     placeholder="Select female"
//                     loading={loadingAnimals}
//                     disabled={!form.getFieldValue("species")}
//                     onChange={(id) => {
//                       const selected = femaleAnimals.find((a) => a.id === id);
//                       form.setFieldsValue({ female_tag: selected?.tagNumber });
//                     }}
//                     optionFilterProp="children"
//                   >
//                     {femaleAnimals.map((animal) => (
//                       <Select.Option key={animal.id} value={animal.id}>
//                         {animal.tagNumber} - {animal.breed || "Unknown Breed"}
//                         {animal.weight && ` (${animal.weight}kg)`}
//                       </Select.Option>
//                     ))}
//                   </Select>
//                 </Form.Item>
//               </Col>
//               <Col span={12}>
//                 <Form.Item name="female_tag" hidden>
//                   <Input />
//                 </Form.Item>
//               </Col>
//             </Row>

//             <Row gutter={16}>
//               <Col span={12}>
//                 <Form.Item name="male_id" label="Male Animal (Optional)">
//                   <Select
//                     showSearch
//                     placeholder="Select male"
//                     loading={loadingAnimals}
//                     disabled={!form.getFieldValue("species")}
//                     allowClear
//                     onChange={(id) => {
//                       const selected = maleAnimals.find((a) => a.id === id);
//                       form.setFieldsValue({ male_tag: selected?.tagNumber });
//                     }}
//                     optionFilterProp="children"
//                   >
//                     {maleAnimals.map((animal) => (
//                       <Select.Option key={animal.id} value={animal.id}>
//                         {animal.tagNumber} - {animal.breed || "Unknown Breed"}
//                         {animal.weight && ` (${animal.weight}kg)`}
//                       </Select.Option>
//                     ))}
//                   </Select>
//                 </Form.Item>
//               </Col>
//               <Col span={12}>
//                 <Form.Item name="male_tag" hidden>
//                   <Input />
//                 </Form.Item>
//               </Col>
//             </Row>

//             <Form.Item
//               name="mating_date"
//               label="Mating Date"
//               rules={[{ required: true }]}
//             >
//               <DatePicker style={{ width: "100%" }} />
//             </Form.Item>

//             <Form.Item name="method" label="Method" initialValue="Natural">
//               <Select>
//                 <Option value="Natural">Natural</Option>
//                 <Option value="AI">Artificial Insemination</Option>
//               </Select>
//             </Form.Item>

//             <Form.Item name="remarks" label="Remarks">
//               <Input.TextArea rows={3} placeholder="Additional notes..." />
//             </Form.Item>
//           </Form>
//         </Modal>

//         {/* Status Update Modal */}
//         <Modal
//           title="Update Mating Status"
//           open={statusModal}
//           onCancel={() => setStatusModal(false)}
//           onOk={() => form.submit()}
//         >
//           <Form form={form} layout="vertical" onFinish={handleStatusSubmit}>
//             <Form.Item
//               label="Status"
//               name="status"
//               rules={[{ required: true, message: "Please select a status" }]}
//             >
//               <Select placeholder="Select Status">
//                 <Option value="Pending">Pending</Option>
//                 <Option value="Served">Served</Option>
//                 <Option value="Pregnant">Confirmed Pregnant</Option>
//                 <Option value="Not Pregnant">Not Pregnant</Option>
//                 <Option value="Aborted">Aborted</Option>
//                 <Option value="Missed">Missed</Option>
//                 <Option value="Delivered">Delivered</Option>
//               </Select>
//             </Form.Item>
//             <Form.Item name="notes" label="Notes">
//               <Input.TextArea rows={2} placeholder="Additional notes..." />
//             </Form.Item>
//           </Form>
//         </Modal>

//         {/* History Modal */}
//         <Modal
//           title="Mating Status History"
//           open={historyVisible}
//           onCancel={() => setHistoryVisible(false)}
//           footer={null}
//           width={700}
//         >
//           <Table
//             dataSource={historyData}
//             columns={[
//               {
//                 title: "Old Status",
//                 dataIndex: "old_status",
//                 render: (text) => (
//                   <Tag color={text ? "blue" : "default"}>
//                     {text || "— Initial —"}
//                   </Tag>
//                 ),
//               },
//               {
//                 title: "New Status",
//                 dataIndex: "new_status",
//                 render: (text) => <Tag color="green">{text || "N/A"}</Tag>,
//               },
//               {
//                 title: "Notes",
//                 dataIndex: "notes",
//                 render: (text) => text || "-",
//               },
//               {
//                 title: "Changed At",
//                 dataIndex: "changed_at",
//                 render: (text) =>
//                   text ? dayjs(text).format("DD MMM YYYY, h:mm A") : "—",
//               },
//               {
//                 title: "Changed By",
//                 dataIndex: "changed_by_name",
//                 render: (text) => text || "System",
//               },
//             ]}
//             rowKey="changed_at"
//             pagination={false}
//             size="small"
//           />
//         </Modal>

//         {/* Details Modal */}
//         <Modal
//           title="Mating Record Details"
//           open={detailsModal}
//           onCancel={() => {
//             setDetailsModal(false);
//             setSelectedMating(null);
//           }}
//           footer={[
//             <Button key="close" onClick={() => setDetailsModal(false)}>
//               Close
//             </Button>,
//           ]}
//           width={600}
//         >
//           {selectedMating && (
//             <>
//               <Descriptions bordered column={2} size="small">
//                 <Descriptions.Item label="Species">
//                   <Tag color="blue" style={{ textTransform: "uppercase" }}>
//                     {selectedMating.species}
//                   </Tag>
//                 </Descriptions.Item>
//                 <Descriptions.Item label="Method">
//                   {selectedMating.method || "Natural"}
//                 </Descriptions.Item>
//                 <Descriptions.Item label="Female Tag">
//                   <Tag color="pink">{selectedMating.female_tag}</Tag>
//                 </Descriptions.Item>
//                 <Descriptions.Item label="Female Breed">
//                   {selectedMating.female_breed || "-"}
//                 </Descriptions.Item>
//                 <Descriptions.Item label="Male Tag">
//                   {selectedMating.male_tag ? (
//                     <Tag color="cyan">{selectedMating.male_tag}</Tag>
//                   ) : (
//                     "-"
//                   )}
//                 </Descriptions.Item>
//                 <Descriptions.Item label="Male Breed">
//                   {selectedMating.male_breed || "-"}
//                 </Descriptions.Item>
//                 <Descriptions.Item label="Mating Date">
//                   {dayjs(selectedMating.mating_date).format("DD MMM YYYY")}
//                 </Descriptions.Item>
//                 <Descriptions.Item label="Expected Due Date">
//                   {selectedMating.expected_due_date
//                     ? dayjs(selectedMating.expected_due_date).format(
//                         "DD MMM YYYY",
//                       )
//                     : "Not calculated"}
//                 </Descriptions.Item>
//                 <Descriptions.Item label="Status" span={2}>
//                   <Tag color={getStatusColor(selectedMating.status)}>
//                     {selectedMating.status || "Pending"}
//                   </Tag>
//                 </Descriptions.Item>
//                 <Descriptions.Item label="Remarks" span={2}>
//                   {selectedMating.remarks || "-"}
//                 </Descriptions.Item>
//               </Descriptions>
//               <Divider />
//               <div style={{ textAlign: "center", padding: 20 }}>
//                 <Text type="secondary">
//                   Offspring will be recorded when pregnancy is confirmed and
//                   birth occurs.
//                 </Text>
//               </div>
//             </>
//           )}
//         </Modal>
//       </Card>
//     </ConfigProvider>
//   );
// };

// export default MatingRecords;

import React, { useState, useRef, useEffect } from "react";
import {
  Card,
  Modal,
  Form,
  Select,
  DatePicker,
  Input,
  Tag,
  message,
  Table,
  Space,
  Badge,
  Tooltip,
  Descriptions,
  Divider,
  Typography,
  Button,
  Row,
  Col,
  ConfigProvider,
  Statistic,
  Progress,
  Alert,
  Tabs,
  Spin,
} from "antd";
import { ProTable } from "@ant-design/pro-table";
import axios from "axios";
import dayjs from "dayjs";
import config from "../../config";
import {
  PlusOutlined,
  HistoryOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EyeOutlined,
  RiseOutlined,
  FallOutlined,
  TeamOutlined,
  CalendarOutlined,
  HeartOutlined,
  StockOutlined,
} from "@ant-design/icons";
import enUS from "antd/lib/locale/en_US";
import { useSelector } from "react-redux";

const { Option } = Select;
const { Text } = Typography;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

const MatingRecords = () => {
  const actionRef = useRef();
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [historyVisible, setHistoryVisible] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedMating, setSelectedMating] = useState(null);
  const [maleAnimals, setMaleAnimals] = useState([]);
  const [femaleAnimals, setFemaleAnimals] = useState([]);
  const [loadingAnimals, setLoadingAnimals] = useState(false);
  const [stats, setStats] = useState({
    summary: {},
    bySpecies: [],
    monthlyTrend: [],
  });
  const [loadingStats, setLoadingStats] = useState(false);
  const [activeTab, setActiveTab] = useState("records");
  const account = useSelector((state) => state.account.user);

  const environment =
    window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;

  // Fetch statistics
  // Update the fetchStatistics function
  const fetchStatistics = async () => {
    setLoadingStats(true);
    try {
      const { data } = await api.get(`/mating/statistics`);
      // The API now returns { summary: {...}, bySpecies: [...] }
      setStats({
        summary: data.summary || {},
        bySpecies: data.bySpecies || [],
      });
    } catch (error) {
      console.error("Error fetching statistics:", error);
      // Set default empty stats on error
      setStats({
        summary: {},
        bySpecies: [],
      });
    } finally {
      setLoadingStats(false);
    }
  };

  // Update the conception rate calculation
  const calculateConceptionRate = () => {
    const total = stats.summary?.total_matings || 0;
    const pregnant = stats.summary?.confirmed_pregnant || 0;
    if (total === 0) return 0;
    return ((pregnant / total) * 100).toFixed(1);
  };

  // Update the summary display to use stats.summary
  const summary = stats.summary || {};
  const bySpecies = stats.bySpecies || [];
  const conceptionRate = calculateConceptionRate();

  useEffect(() => {
    fetchStatistics();
  }, []);

  // Fetch animals from animal_assets by species and gender
  const fetchAnimalsByType = async (species, gender) => {
    if (!species) return [];
    setLoadingAnimals(true);
    try {
      const params = {
        type_slug: species,
        gender: gender,
        status: "alive",
        archived: false,
      };
      const { data } = await api.get(`/animal-assets/available`, {
        params,
      });
      return data;
    } catch (error) {
      console.error(`Error fetching ${gender} ${species}:`, error);
      return [];
    } finally {
      setLoadingAnimals(false);
    }
  };

  // Handle species change
  const handleSpeciesChange = async (species) => {
    form.setFieldsValue({
      female_id: null,
      male_id: null,
      female_tag: null,
      male_tag: null,
    });
    if (species) {
      const females = await fetchAnimalsByType(species, "female");
      const males = await fetchAnimalsByType(species, "male");
      setFemaleAnimals(females);
      setMaleAnimals(males);
    } else {
      setFemaleAnimals([]);
      setMaleAnimals([]);
    }
  };

  // Add new mating record
  const handleAdd = async (values) => {
    try {
      const payload = {
        species: values.species,
        female_id: values.female_id,
        female_tag: values.female_tag,
        male_id: values.male_id || null,
        male_tag: values.male_tag || null,
        mating_date: values.mating_date.format("YYYY-MM-DD"),
        method: values.method || "Natural",
        remarks: values.remarks || null,
        status: "Served",
        userId: account.id,
        userName: account.firstname,
      };

      const res = await api.post(`/mating/add`, payload);
      if (res.status === 200 || res.status === 201) {
        message.success("Mating record added successfully");
        setOpen(false);
        form.resetFields();
        setFemaleAnimals([]);
        setMaleAnimals([]);
        actionRef.current?.reload();
        fetchStatistics();
      }
    } catch (error) {
      console.error("Error adding mating record:", error.response?.data);
      message.error(
        error.response?.data?.error || "Failed to add mating record",
      );
    }
  };

  // Update status
  const handleStatusSubmit = async (values) => {
    try {
      await api.post(`/mating/update-status`, {
        id: selectedRecord.id,
        status: values.status,
        notes: values.notes,
        userId: account.id,
        userName: account.firstname,
      });
      message.success("Status updated successfully!");
      setStatusModal(false);
      actionRef.current?.reload();
      fetchStatistics();
    } catch (err) {
      console.error(err.response?.data?.error);
      message.error("Failed to update status.");
    }
  };

  // View history
  const viewHistory = async (matingId) => {
    try {
      const res = await api.get(`/mating/status-logs/${matingId}`);
      setHistoryData(res.data);
      setHistoryVisible(true);
    } catch (err) {
      console.error("Failed to fetch logs:", err);
      message.error("Failed to load history");
    }
  };

  // Get status color
  const getStatusColor = (status) => {
    const colors = {
      Pending: "default",
      Served: "processing",
      Pregnant: "success",
      "Not Pregnant": "error",
      Aborted: "warning",
      Missed: "warning",
      Delivered: "success",
    };
    return colors[status] || "default";
  };


  // ProTable columns
  const columns = [
    {
      title: "Species",
      dataIndex: "species",
      key: "species",
      width: 100,
      render: (_, record) => (
        <Text style={{ textTransform: "uppercase" }}>
          {record.species}
        </Text>
      ),
      filters: [
        { text: "Pig", value: "pig" },
        { text: "Goat", value: "goat" },
        { text: "Sheep", value: "sheep" },
      ],
      onFilter: (value, record) => record.species === value,
    },
    {
      title: "Female",
      dataIndex: "female_tag",
      key: "female_tag",
      width: 140,
      render: (_, record) => (
        <Space>
          <Text>{record.female_tag}</Text>
          {record.female_breed && (
            <Text type="secondary" style={{ fontSize: 11 }}>
              ({record.female_breed})
            </Text>
          )}
        </Space>
      ),
    },
    {
      title: "Male",
      dataIndex: "male_tag",
      key: "male_tag",
      width: 140,
      render: (_, record) =>
        record.male_tag ? (
          <Space>
            <Text>{record.male_tag}</Text>
            {record.male_breed && (
              <Text type="secondary" style={{ fontSize: 11 }}>
                ({record.male_breed})
              </Text>
            )}
          </Space>
        ) : (
          <Text type="secondary">—</Text>
        ),
    },
    {
      title: "Mating Date",
      dataIndex: "mating_date",
      key: "mating_date",
      width: 110,
      render: (_, record) => dayjs(record.mating_date).format("DD MMM YYYY"),
      sorter: (a, b) =>
        dayjs(a.mating_date).unix() - dayjs(b.mating_date).unix(),
    },
    {
      title: "Due Date",
      dataIndex: "expected_due_date",
      key: "expected_due_date",
      width: 110,
      render: (_, record) =>
        record.expected_due_date
          ? dayjs(record.expected_due_date).format("DD MMM YYYY")
          : "-",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 140,
      render: (_, record) => (
        <Tooltip title="Click to update status">
          <Tag
            color={getStatusColor(record.status)}
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedRecord(record);
              form.setFieldsValue({ status: record.status, notes: "" });
              setStatusModal(true);
            }}
          >
            {record.status || "Pending"}
          </Tag>
        </Tooltip>
      ),
      filters: [
        { text: "Pending", value: "Pending" },
        { text: "Served", value: "Served" },
        { text: "Pregnant", value: "Pregnant" },
        { text: "Not Pregnant", value: "Not Pregnant" },
        { text: "Aborted", value: "Aborted" },
        { text: "Missed", value: "Missed" },
        { text: "Delivered", value: "Delivered" },
      ],
      onFilter: (value, record) => record.status === value,
    },
    {
      title: "Method",
      dataIndex: "method",
      key: "method",
      width: 100,
      render: (_, record) => record.method || "Natural",
      filters: [
        { text: "Natural", value: "Natural" },
        { text: "AI", value: "AI" },
      ],
      onFilter: (value, record) => (record.method || "Natural") === value,
    },
    {
      title: "Actions",
      key: "actions",
      width: 100,
      render: (_, record) => (
        <Space>
          <Tooltip title="View Details">
            <Button
              type="link"
              size="small"
              icon={<EyeOutlined />}
              onClick={() => {
                setSelectedMating(record);
                setDetailsModal(true);
              }}
            />
          </Tooltip>
          <Tooltip title="View History">
            <Button
              type="link"
              size="small"
              icon={<HistoryOutlined />}
              onClick={() => viewHistory(record.id)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  // Request function for ProTable - FIXED to handle response correctly
  const request = async (params, sort, filter) => {
    try {
      const queryParams = {
        page: params.current || 1,
        limit: params.pageSize || 20,
      };

      if (params.species) queryParams.species = params.species;
      if (params.status) queryParams.status = params.status;
      if (params.method) queryParams.method = params.method;
      if (params.farm) queryParams.farm = params.farm;
      if (params.tag) queryParams.tag = params.tag;

      if (params.mating_date && params.mating_date.length === 2) {
        queryParams.startDate = params.mating_date[0].format("YYYY-MM-DD");
        queryParams.endDate = params.mating_date[1].format("YYYY-MM-DD");
      }

      if (sort && Object.keys(sort).length > 0) {
        const sortField = Object.keys(sort)[0];
        queryParams.sort = `${sortField}:${
          sort[sortField] === "ascend" ? "ASC" : "DESC"
        }`;
      }

      const response = await api.get(`/mating/list`, {
        params: queryParams,
      });

      // Handle both response formats
      let data = [];
      let total = 0;

      if (response.data.data) {
        // Paginated response format
        data = response.data.data;
        total = response.data.pagination?.total || data.length;
      } else if (Array.isArray(response.data)) {
        // Direct array response format
        data = response.data;
        total = data.length;
      } else {
        data = [];
        total = 0;
      }

      return {
        data: data,
        success: true,
        total: total,
      };
    } catch (error) {
      console.error("Fetch error:", error);
      message.error("Failed to fetch mating records.");
      return {
        data: [],
        success: false,
        total: 0,
      };
    }
  };

  // Toolbar actions
  const toolBarRender = () => [
    <Button
      key="add"
      type="primary"
      icon={<PlusOutlined />}
      onClick={() => setOpen(true)}
    >
      Add Mating Record
    </Button>,
  ];

  // Search form fields
  const searchConfig = {
    labelWidth: "auto",
    optionRender: (searchConfig, formProps, dom) => [
      ...dom,
      <Button key="reset" onClick={() => formProps.resetFields()}>
        Reset
      </Button>,
    ],
  };

  return (
    <>
      <Card>
        {/* Statistics Dashboard */}
        <div style={{ marginBottom: 16 }}>
          <Spin spinning={loadingStats}>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={6}>
                <Card size="small">
                  <Statistic
                    title="Total Matings"
                    value={summary.total_matings || 0}
                    prefix={<HeartOutlined />}
                    // valueStyle={{ color: "#1890ff" }}
                  />
                </Card>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <Card size="small">
                  <Statistic
                    title="Conception Rate"
                    value={conceptionRate}
                    suffix="%"
                    prefix={<RiseOutlined />}
                    // valueStyle={{ color: "#52c41a" }}
                  />
                  <Progress
                    percent={parseFloat(conceptionRate)}
                    size="small"
                    strokeColor="#52c41a"
                    showInfo={false}
                    style={{ marginTop: 8 }}
                  />
                </Card>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <Card size="small">
                  <Statistic
                    title="Confirmed Pregnant"
                    value={summary.confirmed_pregnant || 0}
                    prefix={<CheckCircleOutlined />}
                    // valueStyle={{ color: "#52c41a" }}
                  />
                </Card>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <Card size="small">
                  <Statistic
                    title="Gave Birth"
                    value={summary.gave_birth || 0}
                    prefix={<TeamOutlined />}
                    // valueStyle={{ color: "#722ed1" }}
                  />
                </Card>
              </Col>
            </Row>

            {/* Species Breakdown */}
            {bySpecies.length > 0 && (
              <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                {bySpecies.map((species) => (
                  <Col xs={24} sm={12} md={8} key={species.species}>
                    <Card size="small">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          <Text
                            style={{ textTransform: "uppercase" }}
                          >
                            {species.species}
                          </Text>
                          <div
                            style={{
                              fontSize: 20,
                              fontWeight: "bold",
                              marginTop: 8,
                            }}
                          >
                            {species.total_matings}
                          </div>
                          <div style={{ fontSize: 12, color: "#666" }}>
                            Total Matings
                          </div>
                        </div>
                        <div style={{ textAlign: "right" }}>
                          <div
                            style={{
                              fontSize: 20,
                              fontWeight: "bold",
                              color: "#52c41a",
                            }}
                          >
                            {species.confirmed_pregnant || 0}
                          </div>
                          <div style={{ fontSize: 12, color: "#666" }}>
                            Pregnant
                          </div>
                          <div style={{ fontSize: 12, color: "#faad14" }}>
                            {species.conception_rate || 0}% rate
                          </div>
                        </div>
                      </div>
                      <Progress
                        percent={species.conception_rate || 0}
                        size="small"
                        strokeColor="#52c41a"
                        showInfo={false}
                        style={{ marginTop: 8 }}
                      />
                    </Card>
                  </Col>
                ))}
              </Row>
            )}

            {/* Success Alert for good conception rate */}
            {conceptionRate > 70 && (
              <Alert
                message="Good Conception Rate!"
                description={`Your overall conception rate is ${conceptionRate}%, which is above the industry average. Keep up the good management practices!`}
                type="success"
                showIcon
                style={{ marginTop: 16 }}
              />
            )}

            {conceptionRate < 50 && conceptionRate > 0 && (
              <Alert
                message="Low Conception Rate"
                description={`Your conception rate is ${conceptionRate}%. Consider reviewing breeding management, nutrition, and health protocols.`}
                type="warning"
                showIcon
                style={{ marginTop: 16 }}
              />
            )}
          </Spin>
        </div>

        {/* Tabs for Records and Analytics */}
        <Tabs activeKey={activeTab} onChange={setActiveTab}>
          <TabPane tab="Mating Records" key="records">
            <ProTable
              actionRef={actionRef}
              columns={columns}
              request={request}
              rowKey="id"
              defaultSize="small"
              search={searchConfig}
              toolBarRender={toolBarRender}
              pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
              }}
              dateFormatter="string"
              scroll={{ x: 1000 }}
              options={{
                reload: true,
                density: true,
                setting: true,
              }}
            >
              <ProTable.Column
                title="Mating Date Range"
                dataIndex="mating_date"
                key="mating_date"
                valueType="dateRange"
                hideInTable
                fieldProps={{
                  placeholder: ["Start Date", "End Date"],
                }}
              />
              <ProTable.Column
                title="Tag Number"
                dataIndex="tag"
                key="tag"
                valueType="text"
                hideInTable
                fieldProps={{
                  placeholder: "Search by tag number",
                }}
              />
              <ProTable.Column
                title="Farm"
                dataIndex="farm"
                key="farm"
                valueType="text"
                hideInTable
                fieldProps={{
                  placeholder: "Farm ID",
                }}
              />
            </ProTable>
          </TabPane>

          <TabPane tab="Breeding Analytics" key="analytics">
            <Spin spinning={loadingStats}>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <Card title="Breeding Performance Overview">
                    <Row gutter={[16, 16]}>
                      <Col xs={24} sm={12} md={6}>
                        <Card size="small">
                          <Statistic
                            title="Total Matings"
                            value={summary.total_matings || 0}
                            prefix={<HeartOutlined />}
                            valueStyle={{ color: "#1890ff" }}
                          />
                        </Card>
                      </Col>
                      <Col xs={24} sm={12} md={6}>
                        <Card size="small">
                          <Statistic
                            title="Conception Rate"
                            value={conceptionRate}
                            suffix="%"
                            prefix={<RiseOutlined />}
                            valueStyle={{ color: "#52c41a" }}
                          />
                          <Progress
                            percent={parseFloat(conceptionRate)}
                            size="small"
                            strokeColor="#52c41a"
                            showInfo={false}
                          />
                        </Card>
                      </Col>
                      <Col xs={24} sm={12} md={6}>
                        <Card size="small">
                          <Statistic
                            title="Confirmed Pregnant"
                            value={summary.confirmed_pregnant || 0}
                            prefix={<CheckCircleOutlined />}
                            valueStyle={{ color: "#52c41a" }}
                          />
                        </Card>
                      </Col>
                      <Col xs={24} sm={12} md={6}>
                        <Card size="small">
                          <Statistic
                            title="Gave Birth"
                            value={summary.gave_birth || 0}
                            prefix={<TeamOutlined />}
                            valueStyle={{ color: "#722ed1" }}
                          />
                        </Card>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </Spin>
          </TabPane>
        </Tabs>

        {/* Add Mating Record Modal */}
        <Modal
          title="Add Mating Record"
          open={open}
          onCancel={() => {
            setOpen(false);
            form.resetFields();
            setFemaleAnimals([]);
            setMaleAnimals([]);
          }}
          onOk={() => form.submit()}
          okText="Save"
          width={600}
        >
          <Form form={form} layout="vertical" onFinish={handleAdd}>
            <Form.Item
              name="species"
              label="Species"
              rules={[{ required: true }]}
            >
              <Select
                onChange={handleSpeciesChange}
                placeholder="Select species"
                options={[
                  { label: "🐷 Pig", value: "pig" },
                  { label: "🐑 Sheep", value: "sheep" },
                  { label: "🐐 Goat", value: "goat" },
                ]}
              />
            </Form.Item>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="female_id"
                  label="Female Animal"
                  rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    placeholder="Select female"
                    loading={loadingAnimals}
                    disabled={!form.getFieldValue("species")}
                    onChange={(id) => {
                      const selected = femaleAnimals.find((a) => a.id === id);
                      form.setFieldsValue({ female_tag: selected?.tagNumber });
                    }}
                    optionFilterProp="children"
                  >
                    {femaleAnimals.map((animal) => (
                      <Select.Option key={animal.id} value={animal.id}>
                        {animal.tagNumber} - {animal.breed || "Unknown Breed"}
                        {animal.weight && ` (${animal.weight}kg)`}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="female_tag" hidden>
                  <Input />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item name="male_id" label="Male Animal (Optional)">
                  <Select
                    showSearch
                    placeholder="Select male"
                    loading={loadingAnimals}
                    disabled={!form.getFieldValue("species")}
                    allowClear
                    onChange={(id) => {
                      const selected = maleAnimals.find((a) => a.id === id);
                      form.setFieldsValue({ male_tag: selected?.tagNumber });
                    }}
                    optionFilterProp="children"
                  >
                    {maleAnimals.map((animal) => (
                      <Select.Option key={animal.id} value={animal.id}>
                        {animal.tagNumber} - {animal.breed || "Unknown Breed"}
                        {animal.weight && ` (${animal.weight}kg)`}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="male_tag" hidden>
                  <Input />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              name="mating_date"
              label="Mating Date"
              rules={[{ required: true }]}
            >
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>

            <Form.Item name="method" label="Method" initialValue="Natural">
              <Select>
                <Option value="Natural">Natural</Option>
                <Option value="AI">Artificial Insemination</Option>
              </Select>
            </Form.Item>

            <Form.Item name="remarks" label="Remarks">
              <Input.TextArea rows={3} placeholder="Additional notes..." />
            </Form.Item>
          </Form>
        </Modal>

        {/* Status Update Modal */}
        <Modal
          title="Update Mating Status"
          open={statusModal}
          onCancel={() => setStatusModal(false)}
          onOk={() => form.submit()}
        >
          <Form form={form} layout="vertical" onFinish={handleStatusSubmit}>
            <Form.Item
              label="Status"
              name="status"
              rules={[{ required: true, message: "Please select a status" }]}
            >
              <Select placeholder="Select Status">
                <Option value="Pending">Pending</Option>
                <Option value="Served">Served</Option>
                <Option value="Pregnant">Confirmed Pregnant</Option>
                <Option value="Not Pregnant">Not Pregnant</Option>
                <Option value="Aborted">Aborted</Option>
                <Option value="Missed">Missed</Option>
                <Option value="Delivered">Gave Birth</Option>
              </Select>
            </Form.Item>
            <Form.Item name="notes" label="Notes">
              <Input.TextArea rows={2} placeholder="Additional notes..." />
            </Form.Item>
          </Form>
        </Modal>

        {/* History Modal */}
        <Modal
          title="Mating Status History"
          open={historyVisible}
          onCancel={() => setHistoryVisible(false)}
          footer={null}
          width={700}
        >
          <Table
            dataSource={historyData}
            columns={[
              {
                title: "Old Status",
                dataIndex: "old_status",
                render: (text) => (
                  <Tag color={text ? "blue" : "default"}>
                    {text || "— Initial —"}
                  </Tag>
                ),
              },
              {
                title: "New Status",
                dataIndex: "new_status",
                render: (text) => <Tag color="green">{text || "N/A"}</Tag>,
              },
              {
                title: "Notes",
                dataIndex: "notes",
                render: (text) => text || "-",
              },
              {
                title: "Changed At",
                dataIndex: "changed_at",
                render: (text) =>
                  text ? dayjs(text).format("DD MMM YYYY, h:mm A") : "—",
              },
              {
                title: "Changed By",
                dataIndex: "changed_by_name",
                render: (text) => text || "System",
              },
            ]}
            rowKey="changed_at"
            pagination={false}
            size="small"
          />
        </Modal>

        {/* Details Modal */}
        <Modal
          title="Mating Record Details"
          open={detailsModal}
          onCancel={() => {
            setDetailsModal(false);
            setSelectedMating(null);
          }}
          footer={[
            <Button key="close" onClick={() => setDetailsModal(false)}>
              Close
            </Button>,
          ]}
          width={600}
        >
          {selectedMating && (
            <>
              <Descriptions bordered column={2} size="small">
                <Descriptions.Item label="Species">
                  <Tag color="blue" style={{ textTransform: "uppercase" }}>
                    {selectedMating.species}
                  </Tag>
                </Descriptions.Item>
                <Descriptions.Item label="Method">
                  {selectedMating.method || "Natural"}
                </Descriptions.Item>
                <Descriptions.Item label="Female Tag">
                  <Tag color="pink">{selectedMating.female_tag}</Tag>
                </Descriptions.Item>
                <Descriptions.Item label="Female Breed">
                  {selectedMating.female_breed || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Male Tag">
                  {selectedMating.male_tag ? (
                    <Tag color="cyan">{selectedMating.male_tag}</Tag>
                  ) : (
                    "-"
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="Male Breed">
                  {selectedMating.male_breed || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Mating Date">
                  {dayjs(selectedMating.mating_date).format("DD MMM YYYY")}
                </Descriptions.Item>
                <Descriptions.Item label="Expected Due Date">
                  {selectedMating.expected_due_date
                    ? dayjs(selectedMating.expected_due_date).format(
                        "DD MMM YYYY",
                      )
                    : "Not calculated"}
                </Descriptions.Item>
                <Descriptions.Item label="Status" span={2}>
                  <Tag color={getStatusColor(selectedMating.status)}>
                    {selectedMating.status || "Pending"}
                  </Tag>
                </Descriptions.Item>
                <Descriptions.Item label="Remarks" span={2}>
                  {selectedMating.remarks || "-"}
                </Descriptions.Item>
              </Descriptions>
              <Divider />
              <div style={{ textAlign: "center", padding: 20 }}>
                <Text type="secondary">
                  Offspring will be recorded when pregnancy is confirmed and
                  birth occurs.
                </Text>
              </div>
            </>
          )}
        </Modal>
      </Card>
    </>
  );
};

export default MatingRecords;
